document.addEventListener('DOMContentLoaded', function () {
  // Function to force desktop state - always open
  function forceDesktopState() {
    const detailsElements = document.querySelectorAll(
      'details[data-desktop-open]'
    );

    detailsElements.forEach((details) => {
      // On desktop, details should be open by default and not interactive
      details.setAttribute('open', '');

      // Reset any inline styles from animations that might prevent proper display
      const content = details.querySelector('.disclosure__panel');
      if (content) {
        content.style.height = 'auto';
        content.style.opacity = '1';
      }

      // Disable click events on summary for desktop
      const summary = details.querySelector('summary');
      if (summary) {
        summary.style.pointerEvents = 'none';
      }
    });
  }

  // Function to handle mobile/desktop state
  function handleDetailsElements() {
    const detailsElements = document.querySelectorAll(
      'details[data-desktop-open]'
    );
    const isMobile = window.matchMedia(
      window.themeVariables.breakpoints['sm-max']
    ).matches;

    if (isMobile) {
      // On mobile, details should always be closed by default
      detailsElements.forEach((details) => {
        // Always close on mobile
        details.removeAttribute('open');

        // Reset any inline styles from animations
        const content = details.querySelector('.disclosure__panel');
        if (content) {
          content.style.height = '';
          content.style.opacity = '';
        }

        // Enable click events on summary for mobile
        const summary = details.querySelector('summary');
        if (summary) {
          summary.style.pointerEvents = 'auto';
        }
      });
    } else {
      // On desktop, ALWAYS force open state
      forceDesktopState();
    }

    // No need to track initialization status anymore as we always enforce the correct state
  }

  // Function to handle animations on mobile only
  function setupAnimations() {
    const detailsElements = document.querySelectorAll(
      'details[data-desktop-open]'
    );

    detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.disclosure__panel');

      // Only add click handlers on mobile
      summary.addEventListener('click', function (e) {
        // Only handle animations on mobile
        if (
          !window.matchMedia(window.themeVariables.breakpoints['sm-max'])
            .matches
        ) {
          // On desktop, prevent toggling
          e.preventDefault();
          return;
        }

        e.preventDefault();

        // Toggle the open state
        if (details.hasAttribute('open')) {
          // Closing animation
          content.style.height = content.scrollHeight + 'px';
          // Force a reflow
          content.offsetHeight;
          content.style.height = '0';
          content.style.opacity = '0';

          // Remove the open attribute after animation completes
          setTimeout(() => {
            details.removeAttribute('open');
          }, 300);
        } else {
          // Opening animation
          details.setAttribute('open', '');
          // Force a reflow
          content.offsetHeight;
          content.style.height = content.scrollHeight + 'px';
          content.style.opacity = '1';

          // Remove the height after animation completes to allow for responsive changes
          setTimeout(() => {
            content.style.height = 'auto';
          }, 300);
        }
      });
    });
  }

  // Function to handle window resize events
  function handleResize() {
    const isMobile = window.matchMedia(
      window.themeVariables.breakpoints['sm-max']
    ).matches;
    const detailsElements = document.querySelectorAll(
      'details[data-desktop-open]'
    );

    if (!isMobile) {
      // ALWAYS force desktop state on resize to desktop
      forceDesktopState();
    } else {
      // On mobile, ensure all details are closed and interactive
      detailsElements.forEach((details) => {
        // Close the details element
        details.removeAttribute('open');

        // Reset any inline styles from animations
        const content = details.querySelector('.disclosure__panel');
        if (content) {
          content.style.height = '';
          content.style.opacity = '';
        }

        // Enable click events on summary for mobile
        const summary = details.querySelector('summary');
        if (summary) {
          summary.style.pointerEvents = 'auto';
        }
      });
    }
  }

  // Run on page load
  handleDetailsElements();
  setupAnimations();

  // Run on window resize with debounce to improve performance
  window.addEventListener('resize', handleResize);
});
